import { Helper } from "../../../core/util/helper.js";
import React from "react";
export interface EditSkillNumericTextBoxProps {
    field: string;
    value: number;
    readOnly: boolean;
    onChange: (value: number, field: string) => void;
    onFocus: () => void;
    minValue: number;
    maxValue: number;
    focused: boolean;
    onHover: boolean;
}

export default class EditSkillNumericTextBox extends React.Component<EditSkillNumericTextBoxProps, {

}>{
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    onFocus = () => {
        this.props.onFocus();
    }

    onIncrease = () => {
        let newValue = this.props.value + 1;
        if (newValue <= this.props.maxValue) {
            this.props.onChange(newValue, this.props.field);
        }
    }

    onDegrade = () => {
        let newValue = this.props.value - 1;
        if (newValue >= this.props.minValue) {
            this.props.onChange(newValue, this.props.field);
        }
    }

    render() {
        return <SkillTextBox {...this.props} />
    }
}

class SkillTextBox extends React.Component<EditSkillNumericTextBoxProps, any>{
    private selectRef: HTMLInputElement;
    private numericRef: kendo.ui.NumericTextBox;
    constructor(props) {
        super(props)
        this.state = {}
    }

    private renderProgressBar = () => {
        const lenght: number = Math.round((this.props.value * 100) / this.props.maxValue);
        return (
            <div style={{ height: "6px", display: "flex" }} data-role="progress-bar">
                <div style={{ backgroundColor: "#4caf50", width: lenght + "%", borderRadius: `0 0 ${this.props.value == this.props.maxValue ? "var(--border-radius)" : "0"} var(--border-radius)` }}></div>
                <div style={{ backgroundColor: "#c9c9c9", width: (100 - lenght) + "%", borderRadius: `0 0 var(--border-radius) ${this.props.value == 0 ? "var(--border-radius)" : "0"}` }}></div>
            </div>);

    }

    private onChange = (event) => {
        let value: number = event.sender.value();
        if (!Helper.hasValue(value) || !Helper.isNumber(value)) {
            value = 0;
            this.numericRef.value(0);
        }
        value = Math.floor(value);
        this.props.onChange(value, this.props.field);
    }

    private onFocus = () => {

    }
    componentDidUpdate(prevProps: Readonly<EditSkillNumericTextBoxProps>, prevState: Readonly<any>, snapshot?: any) {
        if(this.props.value !== prevProps.value){
            this.numericRef.value(this.props.value);
        }
    }

    componentDidMount() {
        this.numericRef = $(this.selectRef).kendoNumericTextBox({
            min: this.props.minValue,//this.props.field.min,
            max: this.props.maxValue,//this.props.field.max,
            value: this.props.value,
            format: "#",
            decimals: 0,
            spin: this.onChange,
            change: this.onChange
        }).data("kendoNumericTextBox");
    }

    private isValid = () => {
        return this.props.value >= this.props.minValue && this.props.value <= this.props.maxValue;
    }

    render() {
        return (
            <>
                <style>
                    {
                        `
                        .skillTextBox .k-numerictextbox{
                            border-radius: var(--border-radius) var(--border-radius) 0 0; 
                            border: none
                        }

                        .skillTextBox .k-numerictextbox:focus-within{
                            box-shadow: none; 
                            border-bottom: none; 
                            border: none
                        }

                        .skillTextBox:focus-within div[data-role='progress-bar']{ 
                            border-top-width: 0; 
                            border-radius: 0 0 var(--border-radius) var(--border-radius) ;
                        }

                        .skillTextBox{
                            border-radius: var(--border-radius);
                        }

                        .skillTextBox[data-hover='true']{
                            border: 1px solid black;
                        }

                        .skillTextBox[data-focused='true']{
                            border: 1px solid var(--primary-color);
                        }

                        .skillTextBox[data-focused='false']{
                            border: 1px solid #ced4da;
                        }

                        .skillTextBox[data-isvalid='false']{
                            border: 1px solid #ef5350;
                            box-shadow: 0 0 0 0.25rem #ef535040;
                        }
                        `
                    }
                </style>
                <div className="skillTextBox" data-focused={this.props.focused} data-hover={this.props.onHover} data-isvalid={this.isValid()} >
                    <input
                        readOnly={this.props.readOnly}
                        ref={(ref) => this.selectRef = ref}
                        style={{ width: "100%" }}
                        onFocus={this.props.onFocus}
                        title={!this.isValid() ? kendo.format(Helper.getTranslation("Skills.ValueBetween"), this.props.minValue, this.props.maxValue) : null}
                    />
                    {this.renderProgressBar()}
                </div>
            </>
        )

    }
}

